import { INVESTMENT_PROFILE_TYPE_SDIRA } from "@components/Domain";

type Investment = {
  profileType?: string;
};

const isSdiraInvestment = ({ profileType }: Investment): boolean => {
  const isSdira = profileType === INVESTMENT_PROFILE_TYPE_SDIRA;

  return isSdira;
};

export default isSdiraInvestment;
